export default class CartItem {
	constructor({ id, productName, count, price, photo, code, url, checked }) {
		this.id = id;
		this.productName = productName;
		this.count = count;
		this.price = price;
		this.photo = photo;
		this.code = code;
		this.url = url;
		this.checked = checked;
	}
}